import { getRuntimeConfig } from "@/config/runtimeConfig";
import { isCiamTenant } from "@/utils/tenant";

export function Footer() {
  const cfg = getRuntimeConfig();
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white/60 py-6">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-2 px-4 text-xs text-slate-500 sm:flex-row sm:items-center">
        <div>
          © {new Date().getFullYear()} {cfg.companyName}. All rights reserved.
        </div>
        <div className="flex items-center gap-3">
          <span>
            Identity:{" "}
            <span className="font-medium text-slate-700">
              {isCiamTenant() ? "Entra External ID" : "Microsoft Entra"}
            </span>
          </span>
        </div>
      </div>
    </footer>
  );
}
